import React from 'react';
import { useNavigate } from 'react-router-dom';  // Import useNavigate
import classes from './Home.module.scss';
import Fotter from "../Fotter/Fotter";
import Navbar from "../Navbar/Navbar";
import  { useState, useEffect, useRef } from 'react';
import { IoVolumeMuteOutline } from "react-icons/io5";
import { VscUnmute } from "react-icons/vsc";


function Home() {
    const navigate = useNavigate();  // Initialize useNavigate

    // Function to handle navigation
    const handleNavigation = (path) => {
        navigate(path);  // Navigate to the specified path
    };

    const [isMuted, setIsMuted] = useState(true);
    const iframeRef = useRef(null);

    const toggleMute = () => {
        const iframe = iframeRef.current;
        if (!iframe) return;

        // Send postMessage to the iframe to toggle mute
        iframe.contentWindow.postMessage(
            JSON.stringify({
                event: 'command',
                func: isMuted ? 'unMute' : 'mute',
                args: [],
            }),
            '*'
        );

        setIsMuted(!isMuted);
    };


    return (
        <div className={classes['home']}>
            <div className={classes['Navbar-home']}>
                <Navbar />
            </div>

            <div style={{ position: 'relative', width: '100%', paddingTop: '56.25%' }}>
                <iframe
                    ref={iframeRef}
                    src="https://www.youtube.com/embed/GZRFVAoq-7U?autoplay=1&mute=1&enablejsapi=1&controls=0&loop=1&playlist=GZRFVAoq-7U&vq=hd1080"
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        border: 'none',
                        pointerEvents: 'none',
                    }}
                    allow="autoplay; encrypted-media"
                    allowFullScreen
                    title="Autoplay Video"
                />
                <button
                    onClick={toggleMute}
                    style={{
                        position: 'absolute',
                        bottom: '10px',
                        right: '20px',
                        zIndex: 10,
                        opacity: 0.9,
                        backgroundColor: 'transparent',
                        border: '1px solid transparent',
                        borderRadius: '50%',
                        width: '33px',
                        height: '33px',
                        cursor: 'pointer',
                        fontSize: '0',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        pointerEvents: 'auto',
                    }}
                >
                    {isMuted ? (
                            <IoVolumeMuteOutline color={"white"}  size={40}/>
                        // <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24 " width="24">
                        //     <path d="M16.5 12L19 14.5L17.59 15.91L15.09 13.41L12.59 13.91L11.17 14.5L13.67 12L11.17 1.5L12.59 8.09L15.09 10.59L17.59 8.09L19 9.5L16.5 12ZM4 9V15H8L13 20V4L8 9H4Z"/>
                        // </svg>
                    ) : (
                        // <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                        //     <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.74 2.5-2.26 2.5-4.02zm2.5 0c0 3.04-1.64 5.64-4.12 7.03l1.18 1.57C18.87 18.52 21 15.45 21 12s-2.13-6.52-5.44-8.6L14.38 5c2.48 1.39 4.12 4 4.12 7z"/>
                        // </svg>
                        <VscUnmute color={"white"} size={40} />
                    )}
                </button>

            </div>



            <div className={classes['home-section-two']}>

                <div className={classes['section-two-paragraph']}>
                    <p className={classes['paragraph-child-one']}>Science-based technologies effective solutions</p>
                    {/*<p className={classes['paragraph-child-two']}> AUTONOMOUS SOLUTION</p>*/}
                </div>

                <div className={classes['section-two-contents']}>
                    <div className={classes['content-one']} onClick={() => handleNavigation('/news')}>
                        <p>NEWS AND EVENTS</p>
                    </div>
                    <div className={classes['content-two']} onClick={() => handleNavigation('/project')}>
                        <p>PROJECTS</p>
                    </div>
                </div>

                <div className={classes['uav']} onClick={() => handleNavigation('/uav')}>
                    <p>UAV</p>
                </div>
            </div>

            {/*<div className={classes['product-section']}>*/}
            {/*    <div className={classes['product-icons-section']}>*/}
            {/*        <div className={classes['galery-icon']}><p>Gallery</p></div>*/}
            {/*    </div>*/}
            {/*    <div className={classes['aw5-section']}>*/}
            {/*        <div className={classes['aw-5-image']} />*/}
            {/*    </div>*/}
            {/*</div>*/}

            <Fotter />
        </div>
    );
}

export default Home;
